export default {
  // Page titles
  title: 'Customers',
  new_customer: 'New Customer',
  edit_customer: 'Edit Customer',
  customer_detail: 'Customer Details',

  // Descriptions
  description: 'Manage your tenants and prospects',
  new_description: 'Add a new customer to your records',
  edit_description: 'Update customer information',

  // Labels
  labels: {
    first_name: 'First Name',
    last_name: 'Last Name',
    phone: 'Phone',
    email: 'Email',
    id_card_number: 'ID Card',
    tax_id: 'Tax ID',
    address: 'Address',
    status: 'Status',
    source: 'Source',
    customer_info: 'Customer Information',
    lease_status: 'Lease Status',
    account_status: 'Account Status',
    not_provided: 'Not provided',
    leases_count: 'Leases ({{count}})',
  },

  // Placeholders
  placeholders: {
    first_name: 'First name',
    last_name: 'Last name',
    phone: '0812345678',
    email: 'email@example.com',
    id_card_number: '1234567890123',
    tax_id: '0105XXXXXXXXX',
    address: 'e.g., 123 Main St, Bangkok 10110',
    search: 'Search customers...',
    source: 'Select source...',
  },

  // Status
  status: {
    active: 'Active',
    alumni: 'Alumni',
    prospect: 'Prospect',
    external: 'External Parker',
    all: 'All Statuses',
  },

  // Status tabs (lead generation)
  tabs: {
    all: 'All',
    active: 'Active',
    prospects: 'Prospects',
    alumni: 'Alumni',
    external: 'External',
  },

  // LINE badge
  line_badge: 'LINE',

  // Lease section
  lease: {
    title: 'Lease',
    no_lease: 'No lease',
    no_lease_description: 'This customer has no lease.',
    new_lease: 'New Lease',
    create_lease: 'Create Lease',
    monthly_rent: 'Monthly Rent',
    ongoing: 'Ongoing',
    setup_guide_title: 'Connect This Customer to a Unit',
    setup_guide_description:
      'Create a lease to assign this customer to a unit. Make sure you have at least one property with vacant units first.',
    step_1_title: 'Select a vacant unit',
    step_1_description: 'Choose an available unit from one of your properties.',
    step_2_title: 'Set lease terms',
    step_2_description: 'Define the start date, optional end date, and security deposit.',
    step_3_title: 'Sign the lease',
    step_3_description: 'Capture landlord and tenant signatures to activate the agreement.',
  },

  // Empty states
  empty: {
    title: 'No customers',
    description: 'Get started by adding your first customer.',
    no_results: 'No customers found',
  },

  // Setup guide
  setup_guide: {
    title: 'Welcome to Customers',
    description:
      'Customers are your tenants and prospects. Add their contact information here, then assign them to units through leases.',
    step_1_title: 'Add customer information',
    step_1_description: 'Enter their name, phone number, email, and ID card number.',
    step_2_title: 'Assign to a unit via lease',
    step_2_description:
      'After adding a customer, create a lease to connect them to a specific unit.',
    import: 'Import',
    import_off_scope_warning: 'Found {{count}} {{entity}} rows. Import them from the {{Entity}} page.',
    download_sample: 'Download sample',
    seed_sample: 'Seed sample data',
    seed_sample_confirm: 'This will create: 1 sample customer. Continue?',
    seed_sample_success: 'Sample customer created successfully.',
    seed_sample_noop: 'You already have customers. Sample data was not added.',
  },

  // Form sections (EP-86 T011 — Essentials/Advanced grouping)
  sections: {
    essentials: 'Essentials',
    contact: 'Contact',
    ids: 'Identification',
    classification: 'Classification',
    advanced_options: 'Advanced options',
    // List page sort section header (EP-109 T903)
    recent: 'Recent',
  },

  // Status chips
  chips: {
    unpaid: 'Unpaid',
  },

  // Actions
  actions: {
    add_customer: 'Add Customer',
    create_customer: 'Create Customer',
    import: 'Import',
  },

  // Messages
  messages: {
    delete_title: 'Delete Customer',
    delete_confirm: 'Delete customer "{{name}}"? This action cannot be undone.',
    created: 'Customer created successfully',
    updated: 'Customer updated successfully',
    deleted: 'Customer deleted successfully',
    not_found: 'Customer not found',
    identifier_required: 'Please enter at least a name, phone number, or email so this customer can be identified.',
    identifier_required_streamlined: 'Please enter at least a name or phone number so this customer can be identified.',
  },
}
